import React from 'react';

import styles from './styles.module.css';

const FormErrors = ({ errors }: { errors: string[] }) => {
  if (errors.length === 0) return null;
  return (
    <div>
      {errors.map((error, index) => (
        <div className={styles.error} key={index}>
          {error}
        </div>
      ))}
    </div>
  );
};

export default FormErrors;
